import CampaignMagnetDetail from './campaignMagnetDetail'

export default CampaignMagnetDetail
